<template>
  <div class="tab-ls-wrap">
    <div
      v-for="ele in tabs"
      :key="ele.name"
      @click="!$route.fullPath.includes(ele.linkTo) && $router.push(ele.linkTo)"
      :class="['tab-item', { active: $route.fullPath.includes(ele.linkTo) }]"
      :title="ele.name"
    >
      {{ ele.name }}
    </div>
    <span class="copyright">{{$t('settings.copyright')}}
      &nbsp;
      <a
        href="https://beian.miit.gov.cn/"
        target="_blank"
      >{{$t('settings.recordnumber')}}</a>
      &nbsp;
      <a
        href="Javascript:void(0)"
        @click="$router.push('/privacy-policy')"
      >{{$t('settings.privacy')}}</a>
    </span>
  </div>
</template>
<script>
export default {
  name: "container-tab",
  data() {
    return {
      tabs: [],
    };
  },
  computed: {},
  watch: {
    "$i18n.locale"(newValue) {
      this.getOptions();
    },
  },
  methods: {
    getOptions() {
      this.tabs = [
        {
          name: this.$t("route.home"),
          linkTo: "/home",
        },
        {
          name: this.$t("route.case"),
          linkTo: "/case",
        },
        {
          name: this.$t("route.product"),
          linkTo: "/product?topActiveName=topFirst",
        },
        {
          name: this.$t("route.aboutus"),
          linkTo: "/aboutus",
        },
        {
          name: this.$t("route.contactus"),
          linkTo: "/contactus",
        },
        {
          name: this.$t("route.videohub"),
          linkTo: "/videohub",
        },
        {
          name: this.$t("route.news"),
          linkTo: "/news",
        },
      ];
    },
  },
  components: {},
  beforeMount() {
    // 模板编译/挂载之前
  },
  mounted() {
    // 模板编译/挂载之后
  },
  beforeUpdate() {
    // 组件更新之前
  },
  updated() {
    // 组件更新之后
  },
  beforeDestroy() {
    // 组件销毁前调用
    // Tips：你确认删除XX吗？
  },
  created() {
    this.getOptions();
  },
  destroyed() {
    // 组件销毁后调用
    // Tips：当前组件已被删除，清空相关内容
  },
};
</script>
<style lang="less" scoped>
.tab-ls-wrap {
  height: 100%;
  margin: 0.22rem auto;
  display: flex;
  justify-content: center;
  align-content: center;
  position: relative;

  .tab-item {
    width: 10.3rem;
    height: 4.8rem;
    margin-top: 0.3rem;
    position: relative;
    font-size: 1.33rem;
    //font-family: Alibaba PuHuiTi;
    font-family: AlibabaPuHuiTi-Regular;
    font-weight: 400;
    color: #09a8f5;
    line-height: 4.2rem;
    cursor: pointer;
    text-align: center;
    &:after {
      position: absolute;
      content: "";
      display: block;
      width: 8.58rem;
      height: 3.25rem;
      background: url("../assets/pc/btn-default.png") no-repeat 100% 100%;
      background-size: 100% 100%;
      z-index: 10;
      top: 0.5rem;
      left: 0.9rem;
    }
    &:hover,
    &.active {
      background: url("../assets/pc/btn-active.png") no-repeat 100% 100%;
      background-size: 100% 100%;
      font-weight: bold;
      color: #ffffff;
      width: 10.3rem;
      height: 4.8rem;
      margin-top: 0.2rem;
      line-height: 4.4rem;
    }
    &:hover::after,
    &.active:after {
      background: unset;
    }
  }

  .copyright {
    display: inline-block;
    width: 100%;
    //font-family: Alibaba PuHuiTi;
    font-family: AlibabaPuHuiTi-Regular;
    font-size: 1rem;
    font-weight: 400;
    color: #b1b1b1;
    line-height: 2.86rem;
    position: absolute;
    bottom: 0.4rem;
    a {
      font-size: 1rem;
      //font-family: Alibaba PuHuiTi;
      font-family: AlibabaPuHuiTi-Regular;
      font-weight: 400;
      color: #b1b1b1;
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
    }
  }
}
</style>
